import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Router } from '@angular/router';
import { AppGlobals } from '@app/app.global';
import { AuthService, EntityService } from '../services';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  singleSelectEndPoints = ['presigned-url', 'save-invoice-metadata', 'petty-transaction', 'invoice-list-for-tally', 'tally-configuration',
    '/invoice-list-tally',
    '/tally-purchase-ledger-list',
    '/tally-creditable-payable-ledger-list',
    '/tally-taxation-ledger-list',
    '/tally-tds-ledger-list',
    '/tally-tcs-ledger-list',
    '/stored-tally-purchase-ledger-list',
    '/stored-tally-creditable-payable-ledger-list',
    '/stored-tally-taxation-ledger-list',
    '/stored-tally-tds-ledger-list',
    '/stored-tally-tcs-ledger-list',
    '/stored-tally-paid-discount-ledger-list',
    '/stored-tally-received-discount-ledger-list',
    '/stored-tally-round-off-add-ledger-list',
    '/stored-tally-round-off-less-ledger-list',
    '/stored-tally-other-charges-ledger-list',
    '/stored-tally-expense-ledger-list',
    '/stored-tally-product-percentage-ledger-list',
    '/stored-tally-tag-percentage-ledger-list',
    '/stored-tally-sub-category-percentage-ledger-list',
    '/stored-tally-purchase-voucher-config-ledger-list',
    '/stored-tally-expense-voucher-config-ledger-list',
    '/stored-tally-purchase-expense-voucher-config-ledger-list',
    '/stored-tally-voucher-types-list',
    '/stored-tally-supplier-groups-list',
    '/stored-tally-item-groups-list',
    '/stored-tally-purchase-return-voucher-config-ledger-list',
    '/stored-tally-cost-center-ledger-list',
    '/stored-tally-godown-ledger-list',
    '/stored-tally-raw-material-item-ledger-list',
    '/stored-tally-expense-item-ledger-list',
    '/stored-tally-unit-item-ledger-list',
    '/stored-tally-unit-qty-code-list',
    '/units-for-tally',
    '/product-expense-for-tally',
    '/suppliers-for-tally',
    '/tally-ledger-mapping',
    '/tally-ledger-unmap',
    '/auto-map-same-as-description',
    '/auto-map-all-same-as-description',
    '/reset-tally-config',
    '/reset-all-tally-config',
    '/undo-auto-map-same-as-description',
    '/sync-tally-ledgers',
    '/sync-all-tally-ledgers',
    '/auto-map-status',
    '/tally-tcs-ledger-mappings',
    '/tally-tds-ledger-mappings',
    '/tally-taxation-ledger-mappings',
    '/tally-purchase-ledger-mappings',
    '/tally-creditor-payable-ledger-mappings',
    '/tally-paid-discount-ledger-mappings',
    '/tally-received-discount-ledger-mappings',
    '/tally-round-off-add-ledger-mappings',
    '/tally-round-off-less-ledger-mappings',
    '/tally-other-charges-ledger-mappings',
    '/tally-expense-ledger-mappings',
    '/tally-product-percentage-ledger-mappings',
    '/tally-tag-percentage-ledger-mappings',
    '/tally-sub-category-ledger-mappings',
    '/tally-purchase-voucher-config-ledger-mappings',
    '/tally-expense-voucher-config-ledger-mappings',
    '/tally-purchase-expense-voucher-config-ledger-mappings',
    '/tally-purchase-return-voucher-config-ledger-mappings',
    '/tally-cost-center-ledger-mappings',
    '/tally-godown-ledger-mappings',
    '/tally-raw-material-item-ledger-mappings',
    '/tally-expense-item-ledger-mappings',
    '/tally-unit-item-ledger-mappings',
    '/invoice-list-for-tally',
    '/tally-configuration',
    '/products-for-tally',
    '/tally-common-settings',
    '/push-invoice-to-tally',
    '/push-to-petpooja',
    '/hyperpure/orders',
    '/purchase-order',
    '/local-supplier-purchase-order',
    '/last-20-purchase-items',
    '/sign-in',
    '/price-discovery',
    '/purchase-manager',
    '/cart',
    '/check-hyperpure-enabled',
    '/supplier-list?dropdown=true',
    '/supplier-rate-card-items',
    '/update-rate-card-item',
    '/add-supplier-rate-card-with-file',
    '/update-supplier-rate-card-file',
    '/delete-rate-card-item',
    '/add-supplier-rate-card-items',
    '/favorite-items',
    '/purchase-manager/analytics/sync',
    '/purchase-manager/analytics/events',
    '/purchase-manager/analytics/sessions',
    '/purchase-manager/analytics/summary',
    '/dmart/otp',
    '/dmart/login',
    '/dmart/pincode-suggestions',
    '/dmart/pincode-details',
    '/dmart/earliest-slot',
    '/dmart/cart-summary',
    '/dmart/search',
    '/dmart/add-to-cart',
    '/check-integration-status',
    '/purchase-signup/pending-logs',
    '/hyperpure/deactivate',
    '/udaan/upload-document',
    '/upload-invoice',
    '/pm/fast-tags/recent-searched-items',
    '/pm/fast-tags/trending-near-you-items',
  ];
  constructor(private appGlobals: AppGlobals,
    private entityService: EntityService,
    private authService: AuthService,
    public router: Router,) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Skip adding purchase domain headers for external Dmart API calls (direct or via Angular proxy)
    if (request.url.includes('digital.dmart.in') || request.url.startsWith('/dmart-api')) {
      return next.handle(request);
    }

    let headers = this.appGlobals.headers;

    if (request.body instanceof FormData) {
      headers = headers.delete('Content-Type');
    }

    if (request.headers.keys().length) {
      request.headers.keys().forEach(
        header => headers = headers.set(header, request.headers.getAll(header))
      );
    }
    if (this.authService.user?.isOwner && this.entityService.getSelectedEntities()?.length) {
      let entities: any;
      if (this.appGlobals.multiSelectModules.some(path => this.router.url.startsWith(path)) ||
        this.appGlobals.singleSelectModules.some(path => this.router.url.startsWith(path))) {
        if (this.singleSelectEndPoints.some(url => request.url.includes(url))) {
          entities = this.entityService.getSingleSelectedEntity()?.id;
        } else if (this.singleSelectEndPoints.some(url => request.urlWithParams.includes(url)) && request.url.includes('/supplier-list')) {
          entities = this.entityService.getSingleSelectedEntity()?.id;
        } else {
          entities = this.entityService.getSelectedEntities().filter((entity) => entity.id !== '0').map((entity) => entity.id);
        }
      } else if (this.appGlobals.singleSelectCompanyModules.some(path => this.router.url.startsWith(path))) {
        entities = this.entityService.getSingleSelectedCompany()?.id;
      } else if (request.url.includes('/kyc/detail')) {
        entities = this.entityService.getSelectedCompanyForKYC();
      }
      if (entities?.length) {
        headers = headers.set('x-entity-ids', entities.toString());
      }
    }

    // Admin users should only send x-entity-ids header when in Report module
    if (this.authService.user?.isAdmin && this.router.url.startsWith('/report') && this.entityService.getSelectedEntities()?.length) {
      const entities = this.entityService.getSelectedEntities().filter((entity) => entity.id !== '0').map((entity) => entity.id);
      if (entities?.length) {
        headers = headers.set('x-entity-ids', entities.toString());
      }
    }

    return next.handle(request.clone({ headers }));
  }
}